module.exports = __webpack_public_path__ + "static/media/icon-repeat-bet.a23249ef.svg";